import type { Palette } from '@memebattle/ui'

export const palette: Partial<Palette> = {
  primary: {
    main: '#2D8A53',
    dark: '#377757',
    lighter: '#33BE6D',
    light: '#40DD82',
    contrastText: '#fff',
    inactiveLight: '#2FB166',
  },
  background: {
    default: '#247044',
    lighter: '#2C7D4E',
    paper: '#2CAB61',
  },
  text: {
    primary: '#fff',
    secondary: '#fff',
    disabled: 'rgba(255,255,255, 0.5)',
  },
}
